export const AffiliateTypeItems = [
  { label: 'Crypto - Influencer', value: 'Crypto - Influencer' },
  { label: 'Crypto - Organization', value: 'Crypto - Organization' },
  { label: 'Not crypto related', value: 'Not crypto related' },
  { label: 'Quantitative trader', value: 'Quantitative trader' },
  { label: 'Social media content creator', value: 'Social media content creator' },
  { label: 'Website owner', value: 'Website owner' },
  { label: 'Competitor platform', value: 'Competitor platform' },
  { label: 'Other', value: 'Other' },
];

export const PromotedChannelItems = [
  { label: 'YouTube', value: 'YouTube' },
  { label: 'Facebook', value: 'Facebook' },
  { label: 'Instagram', value: 'Instagram' },
  { label: 'Telegram', value: 'Telegram' },
  { label: 'TikTok', value: 'TikTok' },
  { label: 'X (Twitter)', value: 'X (Twitter)' },
  { label: 'Line', value: 'Line' },
  { label: 'Kakao Talk', value: 'Kakao Talk' },
  { label: 'Other', value: 'Other' },
];

export const FollowersItems = [
  { label: '<=100', value: '<=100' },
  { label: '100 to 1,000', value: '100 to 1,000' },
  { label: '1,000 to 5,000', value: '1,000 to 5,000' },
  { label: '5,000 to 10,000', value: '5,000 to 10,000' },
  { label: '10,000 above', value: '10,000 above' },
  { label: 'Other', value: 'Other' },
];

export const HearAboutItems = [
  { label: 'Social media', value: 'Social media' },
  { label: 'Recommended by friends', value: 'Recommended by friends' },
  { label: 'Google', value: 'Google' },
  { label: 'Other', value: 'Other' },
];
